<template>
  <div class="menu-field-list">
    <Action-panel :isReady="isPageReady">
      <Button-base
        :type="2"
        :text="translations.labels.button_add_menuField"
        :hoverInfo="translations.labels.button_add_menuField_hover"
        :onClick="newItem"
      />
    </Action-panel>

    <TableList
      :is-ready="isPageReady"
      :headers="headers"
      :items="model.filter(l => true)"
      :items-per-page="-1"
      sortable
      hideFooter
      @sorted="saveOrder"
      item-key="id"
      :searchVisible="false"
       />
  </div>
</template>

<script>
import Component, { mixins } from "vue-class-component";
import Container from "@/components/dom/Container";
import ActionPanel from "@/components/panel/ActionPanel";
import InnerPanel from "@/components/panel/InnerPanel";
import TablePanel from "@/components/panel/TablePanel";
import ButtonBase from "@/components/dom/ButtonBase";
import SvgIcon from "@/components/dom/SvgIcon";
import Round from "@/components/dom/Round";
import TableList from "@/components/table/TableList";
import Translations from "@/mixins/translations";

@Component({
   components: {
    ActionPanel,
    InnerPanel,
    TablePanel,
    ButtonBase,
    SvgIcon,
    Round,
    Container,
    TableList
  },
  inject: {
    menuService: "menuService",
    eventService: "eventService",
    toastService: "toastService"
  }
})
export default class MenuFieldList extends mixins(Translations) {
  isPageReady = false;
  parentId = null;
  model = [];
  events = [];
  search = "";

  async prepareList () {
    const menu = await this.menuService.read(this.parentId);
    return menu.fields;
  }

  async init () {
    try {
      this.parentId = this.$route.params.idParent;
      this.model = await this.prepareList();
      this.isPageReady = true;
    } catch (error) {
      this.toastService.error(this.translations.errors.somethingWrong);
    }
  }

  toastSuccessLabel (isEnabled) {
    return isEnabled
      ? this.toastService.success(this.translations.success.menu_disable)
      : this.toastService.success(this.translations.success.menu_enable);
  }

  async toggleEnabled(idMenu, isEnabled) {
    const status = isEnabled ? "disable" : "enable";
    this.isPageReady = false;

    try {
      await this.menuService.setEnabled(idMenu, status);
      this.model = await this.prepareList();

      this.toastSuccessLabel(isEnabled);
      this.isPageReady = true;
    } catch (error) {
      this.isPageReady = true;
      this.toastService.error(this.translations.errors.somethingWrong);
    }
  }

  newItem() {
    this.$router.push(`/menu-fields/${this.parentId}/new`);
  }

  get headers() {
    return [
      {
        text: this.translations.labels.menuField_table_code,
        value: "code"
      },
      {
        text: this.translations.labels.table_order,
        value: "order"
      },
      {
        text: this.translations.labels.table_detail,
        value: "detail",
        type: "link",
        icon: "mdi-feature-search-outline",
        formatValue: (item) => {
          return `/menu-fields/${this.parentId}/detail/${item.id}`;
        },
      },
      {
        text: this.translations.labels.table_edit,
        value: "edit",
        type: "link",
        formatValue: (item) => {
          return `/menu-fields/${this.parentId}/edit/${item.id}`;
        },
        icon: "mdi-pencil",
        buttonType: 2,
      },
      {
        text: this.translations.labels.table_delete,
        value: "delete",
        type: "action",
        icon: "mdi-delete",
        onAction: (item) => {
          this.del(this.parentId, item.id);
        },
      },
    ];
  }

  async del (parentId, menuFieldId) {
      const confirm = window.confirm(this.translations.confirmDialog.message);
      if (confirm) {
        this.isPageReady = false;
        await this.menuService.deleteField(parentId, menuFieldId);
        this.init();
      }
  }

  mounted () {
    this.init();
    this.$store.commit(
      "SET_SECTION_TITLE",
      this.translations.pageTitles.menuFields_list
    );
  }

  async saveOrder(event) {
    const movedItem = this.model.splice(event.oldIndex, 1);
    this.model.splice(event.newIndex, 0, movedItem[0]);

    let newOrders = [];
    this.model.forEach((m, i) => {
      const index = i + 1;
      this.model[i].order = index;
      newOrders.push({
        id: m.id,
        order: index
      });
    });

    try {
      await this.menuService.saveFieldsOrder(this.parentId, newOrders);
    } catch (e) {
      this.toastService.error(this.translations.errors.somethingWrong);
    }
  }
}

</script>
<style lang="scss" scoped></style>
